import { render, staticRenderFns } from "./StartPreview.vue?vue&type=template&id=4c2b83c5&scoped=true"
import script from "./StartPreview.vue?vue&type=script&lang=js"
export * from "./StartPreview.vue?vue&type=script&lang=js"
import style0 from "./StartPreview.vue?vue&type=style&index=0&id=4c2b83c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b83c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
